


















import { Component, Prop, Emit, Vue } from "vue-property-decorator";

import SimpleMessageDialog from "@/components/common/SimpleMessageDialog.vue";

@Component({
  components: {
    SimpleMessageDialog
  }
})
export default class BrowserSupportDialog extends Vue {
  @Prop({ required: true })
  isDisplayDialog!: boolean;

  @Prop({ required: true })
  isBrowserSupported!: boolean;

  @Prop({ required: true })
  isScreenShareUnsupported!: boolean;

  get dialogTitle() {
    return !this.isBrowserSupported
      ? "Browser not supported"
      : "Browser has limited support";
  }

  get dialogMessages() {
    const messages: string[] = [];
    if (!this.isBrowserSupported) {
      messages.push("Your browser is not supported.");
    }
    if (this.isScreenShareUnsupported) {
      messages.push("Your browser does not support screen share.");
    }
    return messages;
  }

  @Emit()
  hidePrompt() {
    return !this.isDisplayDialog;
  }

  @Emit()
  submit() {
    return !this.isDisplayDialog;
  }
}
